import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'

import styles from './B2becInfoLayout.module.scss'

type B2becInfoLayoutProps = {
  className?: string
} & PropsWithChildren

type TitleProps = {
  title?: ReactNode
  titleExtra?: ReactNode
} & PropsWithChildren

type ContentProps = {
  className?: string | null
} & PropsWithChildren

function B2becInfoLayout(props: B2becInfoLayoutProps) {
  const { className, children } = props

  return <div className={clsx(styles.wrapper, className)}>{children}</div>
}

const Title = ({
  title = undefined,
  titleExtra = undefined,
  children = undefined,
}: TitleProps) => {
  return (
    <section
      className={clsx(
        styles.headingWrapper,
        'full-width-page-component__wrapper',
      )}
    >
      <div className={styles.heading}>
        <div className={styles.headingTitleWrapper}>
          {title && <h1 className={styles.headingTitle}>{title}</h1>}
          {titleExtra}
        </div>
        <div className={styles.headingExtra}>{children}</div>
      </div>
    </section>
  )
}

const Content = ({ children = undefined, className = null }: ContentProps) => {
  return (
    <section className={clsx(styles.contentWrapper, className)}>
      {children}
    </section>
  )
}

B2becInfoLayout.Title = Title
B2becInfoLayout.Content = Content

export default B2becInfoLayout
